/**
 * Directive dpwTooltipInfo
 *
 * @Example
 * ```
 * <dpw-tooltip-entry message="'This is a tooltip'" trigger="hover">
 *     Tooltip Control
 * </dpw-tooltip-entry>
 * ```
 *
 * ```
 * <!-- For Tooltip whose content is bigger than 4 lines, add `tooltip-large` -->
 * <dpw-tooltip-entry message="'This is a very long tooltip'" tooltip-large>
 *     Tooltip Control
 * </dpw-tooltip-entry>
 * ```
 */
angular.module('dpw.components')
    .directive('dpwTooltipEntry', [function () {
        return {
            restrict: 'EA',
            scope: {
                message: '=',
                emptyMsg: '@',
                trigger: '@',
                autoWidth: '@',
                noWrap: '@'
            },
            transclude: true,
            bindToController: true,
            controller: ['$scope', '$timeout', function ($scope, $timeout) {
                var self = this;
                var timeout;
                var isTriggeredByHover = (self.trigger === 'hover');
                var hideMessageInterval = 3000; //ms


                self.isTriggeredByHover = isTriggeredByHover;
                self.showMessage = false;
                self.hoverEntry = function () {
                    isTriggeredByHover && (self.showMessage = true);
                };
                self.mouseenter = function () {
                    clearTimeout();
                };
                self.mouseleave = function () {
                    isTriggeredByHover ? ( self.showMessage = false) : scheduleHideMessage();
                };
                self.clickEntry = function () {
                    if (isTriggeredByHover) {
                        return;
                    }
                    self.showMessage = true;
                    scheduleHideMessage();
                };
                function scheduleHideMessage() {
                    clearTimeout();
                    timeout = $timeout(function () {
                        self.showMessage = false;
                    }, hideMessageInterval);
                }

                function clearTimeout() {
                    timeout && $timeout.cancel(timeout);
                    timeout = void 0;
                }
            }],
            link: function (scope, element, attrs) {
                scope.ctrl.large = 'tooltipLarge' in attrs;
            },
            controllerAs: 'ctrl',
            templateUrl: 'dpw-tooltip-entry.html'
        };
    }]);